import { replaceAmazonTagInUrl } from '../../utility/amazonUtils.js';
/**
 * Swaps out the tag in a given url or adds one if no tag is present.
 * If the url already has a tag, then it just returns the original url.
 * It sorts the array of affiliateTags by precedence and
 * returns the tag with highest precedence.
 *
 *
 * @param url
 * @param affiliateTags
 * @returns
 */
export function swapAffiliateTags(url, affiliateTags) {
    if (affiliateTags && affiliateTags.length) {
        // Post/Page-level tags have precedence over site-level
        affiliateTags.sort((a, b) => b.level - a.level);
        return replaceAmazonTagInUrl(url, affiliateTags[0].value.tag);
    }
    return url;
}
//# sourceMappingURL=tags.js.map